import React from "react"

const moment = require("moment")

export const TimeFormat = cell => {
  const time = cell.value
  return (
    <div>
      {time ? moment(time).format("hh:mm:ss A") : ""}
    </div>
  )
}

export const DurationFormat = cell => {
  const seconds = cell.value
  const hours = Math.floor(seconds / 3600)
  const minutes = Math.floor((seconds % 3600) / 60)
  const secs = seconds % 60

  return (
    <div>
      {`${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(secs).padStart(2, '0')}`}
    </div>
  )
}
